export default class {
    constructor(selector) {
        this.formPreloaderContainer = document.querySelector(selector);
        this.tl = new TimelineMax();

        this.createPreloader();
    }

    createPreloader() {
        const preloaderTamplate = `<div class="form-preloader__ellipsis">
                <div class="form-preloader__circle"></div>
                <div class="form-preloader__circle"></div>
                <div class="form-preloader__circle"></div>
                <div class="form-preloader__circle"></div>
            </div>`

        this.formPreloaderContainer.innerHTML = preloaderTamplate;
        this.formPreloaderContainer.classList.add('form-preloader')
    }

    show() {
        this.tl.clear();
        this.tl.to(this.formPreloaderContainer, 0.3, {opacity: 1, pointerEvents: 'auto', zIndex: 10})
    }

    hide() {
        this.tl.clear();
        this.tl.to(this.formPreloaderContainer, 0.3, {opacity: 0, pointerEvents: 'none', zIndex: -1})
    }
}
